module.exports = __webpack_public_path__ + "favicon/favicon_pad_310.352fbdee.png";